<template>
  <i
    v-if="renderedType === 'content'"
    :aria-hidden="label ? undefined : 'true'"
    :aria-label="label ? undefined : label"
    :class="componentClasses"
    :style="componentStyles"
    v-html="icon"
  />

  <i
    v-else-if="renderedType === 'class'"
    :aria-hidden="label ? undefined : 'true'"
    :aria-label="label ? undefined : label"
    :class="componentClasses"
    :style="componentStyles"
  />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';

import { defaults } from '../../composables/defaults';
import { withIconProps } from '../../composables/props/icon';
import { useSizeProps } from '../../composables/props/size';

const iconProps = withIconProps();

/** Ikona uniwersalna */
export default defineComponent({
  components: {},
  props: {
    icon: iconProps.icon,
    size: iconProps.iconSize,
    family: iconProps.iconFamily,
    label: iconProps.iconLabel,
    class: iconProps.iconClass,
    config: iconProps.iconConfig
  },

  setup(props) {
    const componentName = 'w-icon';

    /** Sposób renderowania */
    const renderedType = computed(() => {
      if (props.family === 'ms-o' || props.family === 'ms-r' || props.family === 'ms-s' || props.family === 'svg') {
        return 'content';
      }

      if (props.family === 'mdi') {
        return 'class';
      }

      return undefined;
    });

    /** Wyliczona klasa ikony zależnie od rodziny ikon */
    const iconClasses = computed(() => {
      if (props.family === 'mdi') {
        return `mdi mdi-${props.icon}`;
      }

      if (props.family === 'ms-o') {
        return `material-symbols-outlined`;
      }

      if (props.family === 'ms-r') {
        return `material-symbols-rounded`;
      }

      if (props.family === 'ms-s') {
        return `material-symbols-sharp`;
      }
    });

    const materialSymbolsConfig = computed(() => {
      if (props.family === 'ms-o' || props.family === 'ms-r' || props.family === 'ms-s') {
        const config = { ...defaults.icons.config };

        if (props.config.fill !== undefined) {
          config.fill = props.config.fill;
        }

        if (props.config.grade !== undefined) {
          config.grade = props.config.grade;
        }

        if (props.config.opticalSize !== undefined) {
          config.opticalSize = props.config.opticalSize;
        }

        if (props.config.weight !== undefined) {
          config.weight = props.config.weight;
        }

        return `font-variation-settings: 'FILL' ${config.fill ? 1 : 0}, 'wght' ${config.weight}, 'GRAD' ${
          config.grade
        }, 'opsz' ${config.opticalSize};`;
      }
      return undefined;
    });

    const componentStyles = computed(() => {
      return materialSymbolsConfig.value;
    });

    /** Wyliczone klasy komponentu */
    const sizeClasses = useSizeProps(componentName, props);

    const componentClasses = computed(() => {
      return [componentName, sizeClasses.value, iconClasses.value, props.class];
    });

    return { renderedType, componentClasses, componentStyles };
  }
});
</script>

<style lang="scss">
@use 'WIcon';
</style>
